import './index.scss'
import { useDispatch } from 'stimulus-use'
import ApplicationController from '@app/javascript/controllers/application_controller'

export class Controller extends ApplicationController {
  static targets = [
    'sortFieldInput',
    'sortFieldSelect',

    'sortDirInput',
    'sortDirSelect'
  ]

  doConnect() {
    useDispatch(this)
  }

  sortingChanged(ev) {
    ev.preventDefault()

    this.dispatch('changed', { field: this.sortField, dir: this.sortDir })
  }

  selectSort(sortFieldValue, sortDirValue, { notify = false } = {}) {
    this.selectSortField(sortFieldValue)
    this.selectSortDir(sortDirValue)

    if (notify) {
      this.dispatch('changed', { field: this.sortField, dir: this.sortDir })
    }
  }

  selectSortField(value) {
    this.sortFieldSelectTarget.controllers['node-selector'].selectNodeWithId(
      `sort_by_${value}`
    )
  }

  selectSortDir(value) {
    this.sortDirSelectTarget.controllers['node-selector'].selectNodeWithId(
      `sort_dir_${value}`
    )
  }

  get sortField() {
    return this.sortFieldInputTarget.value
  }

  get sortDir() {
    return this.sortDirInputTarget.value
  }
}
